import { LEVEL_DESCRIPTIONS } from '@personal-trainer-app/shared/src/utils/questionnaire/questionnaire-form';
import { FITNESS_LEVEL_OPTIONS } from '@personal-trainer-app/shared/src/utils/select-options';

import type { ChoiceCardOption } from '@/components/ui/ChoiceCardSelect';

export { LEVEL_DESCRIPTIONS };

/**
 * Fitness-level choice cards (value + title + description) — shared by the
 * questionnaire Level step and the refine-plan form so the level copy stays in
 * sync between the full-page flow and the modal.
 */
export const FITNESS_LEVEL_CARD_OPTIONS: ChoiceCardOption[] =
  FITNESS_LEVEL_OPTIONS.map((option) => ({
    value: option.value,
    title: option.label,
    description: LEVEL_DESCRIPTIONS[option.value],
  }));
